import { render, staticRenderFns } from "./SlotsTable.vue?vue&type=template&id=c6921f30&scoped=true"
import script from "./SlotsTable.vue?vue&type=script&lang=js"
export * from "./SlotsTable.vue?vue&type=script&lang=js"
import style0 from "./SlotsTable.vue?vue&type=style&index=0&id=c6921f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6921f30",
  null
  
)

export default component.exports